import { render, staticRenderFns } from "./CurrentConferenceView.vue?vue&type=template&id=5d180ef8&"
import script from "./CurrentConferenceView.vue?vue&type=script&lang=ts&"
export * from "./CurrentConferenceView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d180ef8')) {
      api.createRecord('5d180ef8', component.options)
    } else {
      api.reload('5d180ef8', component.options)
    }
    module.hot.accept("./CurrentConferenceView.vue?vue&type=template&id=5d180ef8&", function () {
      api.rerender('5d180ef8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/CurrentConferenceView.vue"
export default component.exports